// src/components/WarnModal.tsx

import React from 'react'
import {
    Alert,
    Button,
    Modal,
    Space,
    Typography
} from 'antd'
import {
    CloseCircleOutlined
} from '@ant-design/icons'

import type { CSSProperties, ReactNode } from 'react'

const { Text } = Typography

interface WarnModalProps {
    isMobile?: boolean
    isOpen: boolean
    onRequestClose: () => void
    title: string
    subtitle: string
    confirm: string
    customStyles?: {
        content?: CSSProperties
        [key: string]: any
    }
    children?: ReactNode
}

interface WarnModalState {
}

class WarnModal extends React.Component<
    WarnModalProps,
    WarnModalState
> {

    render(): React.ReactNode {
        const {
            isMobile = false,
            isOpen,
            onRequestClose,
            title,
            subtitle,
            confirm,
            children
        } = this.props

        return (
            <Modal
                open={isOpen}
                onCancel={onRequestClose}
                footer={null}
                title={title}
                centered
                width={isMobile ? 360 : 480}
                destroyOnHidden
            >
                <Space
                    direction="vertical"
                    size="middle"
                    style={{ width: '100%' }}
                >
                    <Alert
                        type="error"
                        showIcon
                        icon={<CloseCircleOutlined />}
                        message={subtitle}
                        description={
                            <Text>
                                {children}
                            </Text>
                        }
                    />

                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end'
                        }}
                    >
                        <Button
                            type="primary"
                            danger
                            onClick={onRequestClose}
                        >
                            {confirm}
                        </Button>
                    </div>
                </Space>
            </Modal>
        )
    }
}

export default WarnModal